<template>
    <div>
        <div class="page">
            <div class="title">用户信息</div>
            <div class="form">
                <div class="form-item">
                    <div class="form-label">用户昵称：</div>
                    <div class="form-value">{{result.webName||'-'}}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">登录手机号：</div>
                    <div class="form-value">{{result.webTel || '-'}}</div>
                </div>
                <Button type="primary" :style="{marginLeft: '10px',width: '100px'}" @click="$router.replace({ path: '/person/amend'})">更改</Button>
            </div>
        </div>
    </div>
</template>

<script>
import { getAction } from "@/util/require.js";
export default {
    name: "personalCenter",
    components: {
    },
    data() {
        return {
            result: {}
        };
    },
    created() {
        this.getData();
    },
    mounted() {},
    methods: {
        getData(){
            getAction('/hq/webPage/showPersonMes').then(res=>{
                if(res.success){
                    this.result = res.result;
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
.page {
    width: 100%;
    padding: 30px 105px 0 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background: #FFF;
    box-shadow: 0px 7px 24px 0px rgba(8, 124, 232, 0.15);
    border-radius: 2px;
    min-height: 800px;
}
.title{
    font-size: 34px;
    font-family: PingFang;
    font-weight: bold;
    color: #333333;
    
}
.form {
    width: 100%;
    .form-item {
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        margin-top: 30px;
        line-height: 65px;
        height: 65px;
        width: 100%;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
    }
    .form-label{
        font-weight: bold;
    }
    .form-value{
        color: 	#A9A9A9;
        font-weight: 600;
    }
}
</style>
